module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main app-main--search view"
  }, [_c('transition', {
    attrs: {
      "name": "vignette-transition"
    }
  }, [(_vm.showVignette) ? _c('div', {
    staticClass: "pane-vignette pane-vignette--search",
    on: {
      "click": _vm.onVignetteClick
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showPane('search')) ? _c('section', {
    class: ['pane pane--search pane--start', _vm.visibleClass('search')]
  }, [_vm._t("search-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showPane('results')) ? _c('section', {
    class: ['pane pane--results', _vm.visibleClass('results')]
  }, [_vm._t("results-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showPane('preview')) ? _c('section', {
    class: [_vm.previewPaneClass, 'pane', 'pane--preview', 'pane--end', _vm.previewFullWidth ? 'pane--full-width' : null, _vm.visibleClass('preview')]
  }, [_vm._t("preview-pane")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bac7faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PaneView.vue
// module id = 455
// module chunks = 1